export default "__VITE_ASSET__D63W9ufa__"